import ClientForm from '../components/clients/ClientForm';
import ClientTable from '../components/clients/ClientTable';

export default function ClientsPage() {
    return (
        <div className="mg-animate-fade-in">
            <div className="mg-page-header">
                <h1 className="mg-page-title">👥 Clientes</h1>
                <p className="mg-page-subtitle">
                    Gerencie seus clientes e endereços de entrega
                </p>
            </div>

            <div className="row">
                <div className="col-lg-4 mb-4">
                    <ClientForm />
                </div>
                <div className="col-lg-8">
                    <ClientTable />
                </div>
            </div>
        </div>
    );
}
